import { get_el, create_dom_elements, scroll_to } from 'js/utils';
import { ajax } from 'js/functions';
import Hooks from 'classes/Hooks';

export default class Posts_List {

    constructor(container, args = {}){

        this.container = get_el(container)
        this.args = args;

        this.hooks = new Hooks([
            'query_result', 
        ])
    }

    query(args, callback){
        
        args.request_time = Date.now();
        
        ajax(this.args.query, args, res=>{
            
            if( res.request_time !== args.request_time ) {
                return;
            }

            if( typeof callback === 'function' ) {
                callback(res);
            }

            this.hooks.do('query_result', res)
        })
    }

    loading(){
        this.container.classList.add('loading')
    }

    loading_end(){
        this.container.classList.remove('loading')
    }

    add_html(html){
        const elements = create_dom_elements(html, this.container);
        return elements;
    }

    update_html(html){
        this.container.innerHTML = html;
    }

    scroll_top(){
        scroll_to(this.container, 100)
    }
    
}